(ns accounts.tables
  (:require
    [reagent.core :as r]
    [reagent.format :as fmt]
    [css.core :refer [defstyled get-theme]]
    [css.typography :as typo]
    [css.vars :as vars]
    [cljss.core :as cljss]
    [accounts.common :refer [percent-fmt colored-gain-or-loss-s]]
    [util.core :refer [trunc]]
    [very.re-frame.core :as rf]))


(defstyled internal-accounts-s :div
  {})

(defstyled thead-s :div
  {:border-bottom (str "2px solid " (get-theme :primary))
   :display "grid"
   :min-height "48px"
   :grid-template-columns "3fr 2fr 2fr"
   ::cljss/media {[[:max-width "768px"]]
                  {:grid-template-columns "auto 2fr"
                   :padding-bottom "1rem"
                   :border-bottom "0"}}})

(defstyled thead-external-s :div
  {:border-bottom (str "2px solid " (get-theme :primary))
   :display "grid"
   :min-height "48px"
   :grid-template-columns "3fr 2fr"
   ::cljss/media {[[:max-width "768px"]]
                  {:grid-template-columns "1fr"
                   :padding-bottom "1rem"
                   :border-bottom "0"}}})

(defstyled th-s :div
  {:justify-content "flex-end"
   :display "flex"
   :width "100%"
   :&:first-child {:justify-content "flex-start"}
   :align-items "center"
   ::cljss/media {[[:max-width "768px"]]
                  {:&:first-child {:grid-column "span 2"
                                   :border-bottom (str "2px solid " (get-theme :primary))
                                   :padding-bottom "1rem"
                                   :margin-bottom "1rem"}}}})

(defstyled th-total-s :div
  {:display "flex"
   :width "100%"
   :align-items "center"
   :justify-content "flex-end"
   ::cljss/media {[[:max-width "768px"]]
                  {:justify-content "flex-start"}}})

(defstyled th-total-label-s :div
  {:display "none"
   ::cljss/media {[[:max-width "768px"]]
                  {:margin-right ".5rem"
                   :font-size "1.15rem"
                   :display "block"
                   :grid-column "span 2"}}})

(defn gain-or-loss-percent [v]
  (let [plus-or-minus (cond
                        (> v 0) "+"
                        (< v 0) ""
                        :else "")]
    [colored-gain-or-loss-s {:value v
                             :font-weight 700}
     (str plus-or-minus (percent-fmt v))]))

(defstyled to-date-performance-s :div
  {:position "relative"
   :display "flex"
   :justify-content "flex-end"})

(defstyled position-performance-s :div
  {:pointer-events "none"
   :font-size "1.6rem"
   :position "static"
   :top "-0.25rem"
   :right 0
   :bottom 0
   :z-index 1})

(defstyled performance-select-s :select
  {:border-radius 0
   :border "none"
   :background "white"
   :background-image "url(assets/icons/chevron.svg)"
   :background-position "center right"
   :background-repeat "no-repeat"
   :color vars/gray
   :cursor "pointer"
   :font-size "0.87rem"
   :height "1.5rem"
   :position "absolute"
   :width "auto"
   :top "-2rem"
   :padding "0 1rem 0 0"
   :text-align-last "right"
   :-webkit-appearance "none"
   :&:focus {:outline (str "1px dotted " vars/gray)}
   ::cljss/media {[[:max-width "768px"]]
                  {:background-image "url(assets/icons/calendar.svg)"
                   :background-repeat "no-repeat"
                   :background-size "1.5rem"
                   :background-color "transparent"
                   :padding-right "2rem"}}})

(defn to-date-performance [{:keys [performance change-performance]}]
  [to-date-performance-s
   [position-performance-s [gain-or-loss-percent performance]]
   [performance-select-s {:on-change #(change-performance (.. % -target -value))}
    [:option {:disabled true} "Performance"]
    [:option {:value "Year"} "This Year"]
    [:option {:value "Quarter"} "This Quarter"]
    [:option {:value "Month"} "This Month"]]])

(defstyled focused-border-s :div
  {:border-left (with-meta #(cond
                              ;; true = open, show a border
                              (true? %) "4px solid rgb(176,176,176)"
                              ;; string = focused, color the border
                              (string? %) (str "4px solid " %)
                              ;; everything else = closed, hide a border
                              :else "4px solid transparent") :state)
   :border-bottom (str "1px solid " vars/border-light)
   :transition "border-left 400ms"
   ::cljss/media {[[:max-width "768px"]]
                  {:width "calc(100% + 2rem)"
                   :margin-left "-1rem"}}})

(defstyled account-table-s :div
  {:table-layout "fixed"
   :width "100%"})

(defstyled tr-s :div
  {:display "grid"
   :grid-template-columns "3fr 2fr 2fr"
   :&:first-child {:cursor "pointer"}})

(defstyled td-s :div
  {:text-align "right"
   :display "flex"
   :align-items "center"
   :justify-content "flex-end"
   :color vars/gray
   :&:first-child {:padding "1.67rem 1.33rem"
                   :text-align "left"}
   :&:last-child {:padding "1.67rem 1.33rem"}})

(defstyled name-and-type-s :div
  {:display "flex"
   :flex-direction "column"
   :width "100%"})

(defstyled account-type-s :span
  {:color "rgb(176,176,176)"
   :font-size "0.87rem"
   :margin-top "0.4rem"
   ::cljss/media {[[:max-width "768px"]]
                  {:font-size "13px"}}})

(defstyled table-label-s :h4
  {:color vars/gray
   :font-size "1rem"
   :line-height "1.25rem"
   :font-weight "bold"})

(defstyled nested-table-s :div
  {:background-color "rgb(246,246,246)"
   :border-collapse "collapse"
   :table-layout "fixed"
   :width "100%"})

(defstyled nested-table-row-s :div
  {:display "grid"
   :grid-template-columns "1fr 1fr 1fr 1fr"
   ::cljss/media {[[:max-width "768px"]]
                  {:grid-template-columns "1fr"}}})

(defstyled nested-td-s :div
  {:border-right "1px solid rgb(218,219,218)"
   :display "flex"
   :flex-direction "column"
   :color vars/gray
   :font-size "0.87rem"
   :padding "1.66rem 1.33rem"
   :&:last-child {:border "none"}
   ::cljss/media {[[:max-width "768px"]]
                  {:padding ".25rem 1rem"
                   :border "none"
                   :display "grid"
                   :grid-template-columns ".4fr .6fr"
                   :align-items "center"
                   :&:first-child {:padding-top "1.5rem"}
                   :&:last-child {:padding-bottom "1.5rem"}}}})

(defstyled nested-td-value-s :div
  {:margin-top ".5rem"
   :font-size "14px"
   :color vars/gray})

(defstyled toggle-i-s :i
  {:font-size "0.87rem"
   :margin-left "0.4rem"})

(defstyled animate-height-s :div
  {:max-height (with-meta #(if % "200px" 0) :open?)
   :overflow "hidden"
   :transform "translateZ(0)"
   :transition "max-height 400ms"})

(defn account-table []
  (let [show-details? (r/atom false)]
    (fn [{:keys [account renderer focused performance]}]
      (let [focused? (= (:id account) (:id focused))]
        [focused-border-s {:state (if focused? (:color focused) (true? @show-details?))}
         [account-table-s
          [tr-s {:on-click #(swap! show-details? not)}
           [td-s
            [name-and-type-s
             [table-label-s {:color vars/gray} (trunc (:name account) 70)]
             [account-type-s (:type account)]]]
           [td-s
            (fmt/currency-format (:market-value account))]
           [td-s
            [gain-or-loss-percent performance]
            [toggle-i-s {:class (if @show-details?
                                  "fas fa-chevron-up"
                                  "fas fa-chevron-down")}]]]]
         [animate-height-s {:open? @show-details?}
          [renderer account]]]))))

(defstyled empty-td-s :div
  {:color vars/gray
   :padding "1rem 0"})

(defn internal-account-details [acc]
  [nested-table-s
   [nested-table-row-s
    [nested-td-s
     [table-label-s {:color vars/gray} "Account Number"]
     [nested-td-value-s (:account-number acc)]]
    [nested-td-s
     [table-label-s {:color vars/gray} "Custodian"]
     [nested-td-value-s (:custodian acc)]]
    [nested-td-s
     [table-label-s {:color vars/gray} "Strategy"]
     [nested-td-value-s (:strategy acc)]]
    [nested-td-s
     [table-label-s {:color vars/gray} "Allocation"]
     [nested-td-value-s (percent-fmt (:percent acc))]]]])

(defn internal-accounts []
  (let [average-performance (rf/subscribe [:average-performance])
        client (rf/subscribe [:client])
        focused (rf/subscribe [:focused-account])
        accounts (rf/subscribe [:internal-accounts])
        perf-selection (r/atom "Year")
        str->kw {"Year" :year-td
                 "Quarter" :quarter-td
                 "Month" :month-td}]
    (fn []
      [internal-accounts-s
       [thead-s
        [th-s [typo/h3 (:name @client)]]
        [th-total-label-s "Total:"]
        [th-total-s
         [typo/h3 {:color (get-theme :primary)} (fmt/currency-format (:total-value @accounts))]]
        [th-s [to-date-performance
               {:performance (get @average-performance (get str->kw @perf-selection))
                :change-performance #(reset! perf-selection %)}]]]
       [:div
        (if (:accounts @accounts)
          (doall
            (for [a (:accounts @accounts)]
              ^{:key (:id a)}
              [:div [:div [account-table
                           {:account a
                            :renderer internal-account-details
                            :focused @focused
                            :performance (get-in a [:performance (get str->kw @perf-selection)])}]]]))
          [:div
           [empty-td-s
            [:span "You have no accounts."]]])]])))

(defn external-account-details [acc]
  [nested-table-s
   [nested-table-row-s
    [nested-td-s
     [table-label-s {:color vars/gray} "Account Number (Last 4 Digits)"]
     [nested-td-value-s (:account-number acc)]]
    [nested-td-s
     [table-label-s {:color vars/gray} "Institution"]
     [nested-td-value-s (:custodian acc)]]
    [nested-td-s
     [table-label-s {:color vars/gray} "Account Type"]
     [nested-td-value-s (:type acc)]]]])

(defstyled no-accounts-td-s :div
  {:padding-top "2.25rem"})

(defn external-accounts [{:keys [total-value accounts]}]
  [:div
   [thead-external-s
    [th-s [typo/h3 "Outside Accounts"]]
    [th-total-label-s "Total:"]
    [th-total-s
     [typo/h3 {:color (get-theme :primary)} (fmt/currency-format total-value)]]]
   [:div
    (if accounts
      (for [a accounts]
        ^{:key (:id a)}
        [:div
         [account-table {:account a
                         :renderer external-account-details}]])
      [no-accounts-td-s
       [:span "You have not added any outside accounts."]])]])
